import { render } from "./trash.vue?vue&type=template&id=6346c2a4&scoped=true"
import script from "./trash.vue?vue&type=script&lang=js"
export * from "./trash.vue?vue&type=script&lang=js"

import "./trash.vue?vue&type=style&index=0&id=6346c2a4&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6346c2a4"]])

export default __exports__